class NewsList {
    constructor() {
        this.section = document.querySelector('.block-posts-list');
        this.filterSelect = document.getElementById('filter-topic');
        this.contentContainer = document.getElementById('news-content');
        this.loadingIndicator = document.getElementById('loading-indicator');
        this.prevBtn = document.getElementById('prev-btn');
        this.nextBtn = document.getElementById('next-btn');
        this.currentPageSpan = document.getElementById('current-page');
        this.lastPageSpan = document.getElementById('last-page');
        this.searchForm = document.getElementById('search-form');
        this.searchInput = document.getElementById('search-input');

        this.category = this.getCategoryFromURL();
        this.headingEl = document.getElementById('goals-page-heading');
        this.breadcrumbList = document.getElementById('layout-breadcrumbs-list');

        // Verifica se os elementos existem antes de inicializar
        if (!this.section || !this.contentContainer) {
            console.error('Elementos essenciais não encontrados');
            return;
        }

        this.initializeFromURL();
        this.initializeFromDOM();
        this.initEvents();
    }

    getTagLabel(tag = '') {
        if (!tag || !this.filterSelect) {
            return '';
        }

        const option = this.filterSelect.querySelector(`option[value="${CSS.escape(tag)}"]`);
        return option?.value ? option.textContent.trim() : '';
    }

    getCategoryName() {
        return this.headingEl?.dataset.categoryName || '';
    }

    escapeHtml(value = '') {
        return String(value)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    updateHeading(tag = '') {
        if (!this.headingEl) {
            return;
        }

        if (tag && this.filterSelect) {
            const option = this.filterSelect.querySelector(`option[value="${CSS.escape(tag)}"]`);
            if (option?.value) {
                this.headingEl.textContent = option.textContent.trim();
                return;
            }
        }

        const categoryName = this.headingEl.dataset.categoryName;
        if (categoryName) {
            this.headingEl.textContent = categoryName;
        }
    }

    updateBreadcrumb(tag = '') {
        if (!this.breadcrumbList || !this.category) {
            return;
        }

        const categoryName = this.getCategoryName();
        if (!categoryName) {
            return;
        }

        const homeLink = this.breadcrumbList.querySelector('li a');
        if (!homeLink) {
            return;
        }

        const homeTitle = this.escapeHtml(homeLink.textContent.trim());
        const homeUrl = this.escapeHtml(homeLink.getAttribute('href') || '/');
        const categoryUrl = this.escapeHtml(`/objetivos/${this.category}`);
        const safeCategoryName = this.escapeHtml(categoryName);
        const linkClass = 'text-black/50 dark:text-dark-dark text-xs font-medium';
        const activeClass = 'active text-dark4d text-xs font-medium';
        const spanClass = 'text-dark4d dark:text-dark-dark text-xs font-medium leading-normal tracking-normal';
        const separator = '<li class="dark:text-dark-dark text-[10px] text-black">-</li>';

        let html = `
            <li class="${linkClass}">
                <a href="${homeUrl}" class="whitespace-nowrap">${homeTitle}</a>
            </li>
            ${separator}
        `;

        const tagLabel = this.getTagLabel(tag);
        if (tagLabel) {
            const safeTagLabel = this.escapeHtml(tagLabel);
            html += `
                <li class="${linkClass}">
                    <a href="${categoryUrl}" class="whitespace-nowrap">${safeCategoryName}</a>
                </li>
                ${separator}
                <li class="${linkClass}">
                    <a href="${categoryUrl}" class="whitespace-nowrap">Tópico</a>
                </li>
                ${separator}
                <li class="${activeClass}">
                    <span class="${spanClass}">${safeTagLabel}</span>
                </li>
            `;
        } else {
            html += `
                <li class="${activeClass}">
                    <span class="${spanClass}">${safeCategoryName}</span>
                </li>
            `;
        }

        this.breadcrumbList.innerHTML = html;
    }

    getCategoryFromURL() {
        const urlPath = window.location.pathname;
        const pathParts = urlPath.split('/');
        return pathParts[2] || '';
    }

    initializeFromURL() {
        const urlPath = window.location.pathname;
        const urlParams = new URLSearchParams(window.location.search);

        const pathParts = urlPath.split('/');
        if (pathParts.includes('topico') && pathParts[pathParts.indexOf('topico') + 1]) {
            this.currentTag = pathParts[pathParts.indexOf('topico') + 1];
            if (this.filterSelect) {
                this.filterSelect.value = this.currentTag;
            }
        } else {
            this.currentTag = '';
        }

        const pageParam = urlParams.get('page');
        this.currentPage = pageParam ? parseInt(pageParam) : 1;

        // Só atualiza se o elemento existir
        if (this.currentPageSpan) {
            this.currentPageSpan.textContent = this.currentPage;
        }
    }

    initializeFromDOM() {
        // Pega informações de paginação do DOM inicial
        this.currentPage = this.currentPageSpan ? (parseInt(this.currentPageSpan.textContent) || 1) : 1;
        this.lastPage = this.lastPageSpan ? (parseInt(this.lastPageSpan.textContent) || 1) : 1;

        // Verifica se os botões estão desabilitados no DOM inicial
        this.isPrevDisabled = this.prevBtn ? this.prevBtn.hasAttribute('disabled') : true;
        this.isNextDisabled = this.nextBtn ? this.nextBtn.hasAttribute('disabled') : true;

        // Aplica os estados corretos
        this.updatePaginationState();
    }

    updatePaginationState() {
        // Só atualiza se os botões existirem
        if (this.prevBtn) {
            this.prevBtn.disabled = this.currentPage <= 1 || this.isPrevDisabled;

            if (this.prevBtn.disabled) {
                this.prevBtn.style.pointerEvents = 'none';
                this.prevBtn.style.opacity = '0.5';
            } else {
                this.prevBtn.style.pointerEvents = 'auto';
                this.prevBtn.style.opacity = '1';
            }
        }

        if (this.nextBtn) {
            this.nextBtn.disabled = this.currentPage >= this.lastPage || this.isNextDisabled;

            if (this.nextBtn.disabled) {
                this.nextBtn.style.pointerEvents = 'none';
                this.nextBtn.style.opacity = '0.5';
            } else {
                this.nextBtn.style.pointerEvents = 'auto';
                this.nextBtn.style.opacity = '1';
            }
        }
    }

    showLoading() {
        if (this.loadingIndicator) {
            this.loadingIndicator.classList.remove('hidden');
        }
        if (this.contentContainer) {
            this.contentContainer.style.opacity = '0.5';
        }
    }

    hideLoading() {
        if (this.loadingIndicator) {
            this.loadingIndicator.classList.add('hidden');
        }
        if (this.contentContainer) {
            this.contentContainer.style.opacity = '1';
        }
    }

    updateURL(tag = '', page = 1) {
        let url = `/objetivos/${this.category}`;

        if (tag) {
            url += `/topico/${tag}`;
        }

        const params = new URLSearchParams();
        if (page > 1) params.append('page', page);

        if (params.toString()) {
            url += '?' + params.toString();
        }

        window.history.pushState({
            tag: tag,
            page: page
        }, '', url);
    }

    updatePagination(pagination) {
        // Só atualiza se os elementos existirem
        if (this.currentPageSpan) {
            this.currentPageSpan.textContent = pagination.current_page;
        }
        if (this.lastPageSpan) {
            this.lastPageSpan.textContent = pagination.last_page;
        }

        // Atualiza propriedades internas
        this.currentPage = pagination.current_page;
        this.lastPage = pagination.last_page;
        this.isPrevDisabled = pagination.on_first_page;
        this.isNextDisabled = !pagination.has_more_pages;

        // Atualiza estado dos botões
        this.updatePaginationState();

        // Oculta a paginação se houver somente 1 página
        const paginationContainer = document.querySelector('.pagination');
        if (paginationContainer) {
            if (pagination.last_page <= 1) {
                paginationContainer.classList.add('hidden');
            } else {
                paginationContainer.classList.remove('hidden');
            }
        }
    }

    loadNews(tag = '', page = 1) {
        this.showLoading();

        const params = new URLSearchParams();
        if (tag) params.append('tag', tag);
        params.append('page', page);

        fetch(`/objetivos/${this.category ? this.category + '/' : ''}api?${params.toString()}`)
            .then(response => response.json())
            .then(data => {
                if (this.contentContainer) {
                    // Verifica se há conteúdo
                    if (data.html.trim() === '') {
                        this.contentContainer.innerHTML = `
                            <div class="col-span-full py-6">
                                <p class="text-center text-lg text-dark">Nenhuma notícia encontrada.</p>
                            </div>
                        `;
                    } else {
                        this.contentContainer.innerHTML = data.html;
                    }
                }

                this.updatePagination(data.pagination);
                this.updateURL(tag, page);
                this.updateHeading(tag);
                this.updateBreadcrumb(tag);
                this.hideLoading();
            })
            .catch(error => {
                console.error('Erro ao carregar notícias:', error);
                if (this.contentContainer) {
                    this.contentContainer.innerHTML = `
                        <div class="col-span-full py-6">
                            <p class="text-center text-lg text-red-600">Erro ao carregar notícias. Tente novamente.</p>
                        </div>
                    `;
                }
                this.hideLoading();
            });
    }

    loadNewsWithoutURL(tag = '', page = 1) {
        this.showLoading();

        const params = new URLSearchParams();
        if (tag) params.append('tag', tag);
        params.append('page', page);

        fetch(`/objetivos/${this.category}/api?${params.toString()}`)
            .then(response => response.json())
            .then(data => {
                if (this.contentContainer) {
                    // Verifica se há conteúdo
                    if (data.html.trim() === '') {
                        this.contentContainer.innerHTML = `
                            <div class="col-span-full py-6">
                                <p class="text-center text-lg text-dark">Nenhuma notícia encontrada.</p>
                            </div>
                        `;
                    } else {
                        this.contentContainer.innerHTML = data.html;
                    }
                }

                this.updatePagination(data.pagination);
                this.updateHeading(tag);
                this.updateBreadcrumb(tag);
                this.hideLoading();
            })
            .catch(error => {
                console.error('Erro ao carregar notícias:', error);
                if (this.contentContainer) {
                    this.contentContainer.innerHTML = `
                        <div class="col-span-full py-6">
                            <p class="text-center text-lg text-red-600">Erro ao carregar notícias. Tente novamente.</p>
                        </div>
                    `;
                }
                this.hideLoading();
            });
    }

    initEvents() {
        if (this.filterSelect) {
            this.filterSelect.addEventListener('change', () => {
                this.currentTag = this.filterSelect.value;
                this.currentPage = 1;
                this.loadNews(this.currentTag, this.currentPage);
            });
        }

        if (this.searchForm) {
            this.searchForm.addEventListener('submit', (e) => {
                e.preventDefault();
                const searchTerm = this.searchInput ? this.searchInput.value.trim() : '';

                if (searchTerm) {
                    const searchParams = new URLSearchParams();
                    searchParams.append('s', searchTerm);
                    searchParams.append('source', 'objetivos');

                    window.location.href = `/busca?${searchParams.toString()}`;
                }
            });
        }

        if (this.prevBtn) {
            this.prevBtn.addEventListener('click', (e) => {
                e.preventDefault();

                if (this.prevBtn.disabled || this.currentPage <= 1 || this.isPrevDisabled) {
                    return;
                }

                this.loadNews(this.currentTag, this.currentPage - 1);
                if (this.section) {
                    this.section.scrollIntoView({ behavior: 'smooth' });
                }
            });
        }

        if (this.nextBtn) {
            this.nextBtn.addEventListener('click', (e) => {
                e.preventDefault();

                if (this.nextBtn.disabled || this.currentPage >= this.lastPage || this.isNextDisabled) {
                    return;
                }

                this.loadNews(this.currentTag, this.currentPage + 1);
                if (this.section) {
                    this.section.scrollIntoView({ behavior: 'smooth' });
                }
            });
        }

        window.addEventListener('popstate', (event) => {
            if (event.state) {
                this.currentTag = event.state.tag || '';
                this.currentPage = event.state.page || 1;

                if (this.filterSelect) {
                    this.filterSelect.value = this.currentTag;
                }

                this.loadNewsWithoutURL(this.currentTag, this.currentPage);
            }
        });
    }
}

if (document.querySelector('.block-posts-list')) {
    new NewsList();
}